import { Button } from '@mui/material'
import React from 'react'

interface AttachFilesProps {
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const AttachFilesInput: React.FC<AttachFilesProps> = ({ onUpload }) => {
  return (
    <Button
      variant='outlined'
      component='label'
      sx={{
        marginRight: 1,
      }}
    >
      Attach Files
      <input
        type='file'
        accept='image/*,application/pdf,.doc,.docx'
        multiple
        hidden
        onChange={e => {
          onUpload(e)
          e.target.value = '' // ✅ Reset input so same file can be selected again
        }}
      />
    </Button>
  )
}

export default AttachFilesInput
